import { useState, useRef, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  IconButton,
} from "@mui/material";
import { Send } from "lucide-react";
import MondayVkd from "./MondayVkd";
//import VisualsPanel from "./VisualsPanel"; // ✅ new import

const Chat = () => {
  const [messages, setMessages] = useState([
    {
      id: 1,
      text: "Hello! I'm your virtual AI assistant. How can I help you today?",
      sender: "assistant",
      timestamp: new Date(),
    },
  ]);
  const [inputValue, setInputValue] = useState("");
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSend = () => {
    if (inputValue.trim() === "") return;
    const newMessage = {
      id: messages.length + 1,
      text: inputValue,
      sender: "user",
      timestamp: new Date(),
    };
    setMessages([...messages, newMessage]);
    setInputValue("");

    setTimeout(() => {
      const assistantMessage = {
        id: messages.length + 2,
        text: "I'm a placeholder response. Actual assistant coming soon!.",
        sender: "assistant",
        timestamp: new Date(),
      };
      setMessages((prev) => [...prev, assistantMessage]);
    }, 1000);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "calc(100vh - 64px)",
        bgcolor: "background.default",
      }}
    >
      {/* ================= LEFT COLUMN: CHAT ================= */}
      <Box
        sx={{
          flex: "1 1 30%", // ✅ narrower chat
          display: "flex",
          flexDirection: "column",
          borderRight: 1,
          borderColor: "divider",
          minHeight: 0,
        }}
      >
        {/* Chat Header */}
        <Paper
          square
          elevation={0}
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            px: 3,
            py: 2,
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexShrink: 0,
          }}
        >
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              bgcolor: "secondary.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontWeight: 500,
              fontSize: 14,
            }}
          >
            AI
          </Box>
          <Typography variant="h6">Vermont Kids Data AI Assistant</Typography>
        </Paper>

        {/* Scrollable Messages */}
        <Box sx={{ flex: 1, overflowY: "auto", p: 3 }}>
          {messages.map((message) => (
            <Box
              key={message.id}
              sx={{
                display: "flex",
                gap: 2,
                mb: 3,
                flexDirection:
                  message.sender === "user" ? "row-reverse" : "row",
                alignItems: "flex-start",
              }}
            >
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  bgcolor:
                    message.sender === "assistant"
                      ? "secondary.main"
                      : "grey.600",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontWeight: 500,
                  fontSize: 14,
                  flexShrink: 0,
                }}
              >
                {message.sender === "assistant" ? "AI" : "U"}
              </Box>

              <Paper
                elevation={0}
                sx={{
                  borderRadius: 2,
                  p: 2,
                  maxWidth: 640,
                  bgcolor:
                    message.sender === "user"
                      ? "grey.100"
                      : "background.paper",
                  border:
                    message.sender === "assistant" ? 1 : "none",
                  borderColor: "divider",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ color: "text.primary", whiteSpace: "pre-wrap" }}
                >
                  {message.text}
                </Typography>
              </Paper>
            </Box>
          ))}
          <div ref={messagesEndRef} />
        </Box>

        {/* Input Bar */}
        <Paper
          square
          elevation={0}
          sx={{
            borderTop: 1,
            borderColor: "divider",
            p: 2,
            flexShrink: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
              alignItems: "flex-end",
            }}
          >
            <TextField
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Type your message..."
              fullWidth
              multiline
              maxRows={4}
              variant="outlined"
              sx={{
                borderRadius: "24px",
                "& .MuiOutlinedInput-root": { borderRadius: "24px" },
              }}
            />
            <IconButton
              color="secondary"
              onClick={handleSend}
              disabled={inputValue.trim() === ""}
              sx={{ width: 44, height: 44, borderRadius: "50%" }}
            >
              <Send size={20} />
            </IconButton>
          </Box>
        </Paper>
      </Box>

      {/* ================= RIGHT COLUMN: MONDAY + VISUALS ================= */}
      <Box
        sx={{
          flex: "1 1 70%", // ✅ wider visuals section
          display: "flex",
          flexDirection: "column",
          gap: 2,
          p: 2,
          overflowY: "auto",
          minHeight: 0,
        }}
      >
        <MondayVkd />
        
      </Box>
    </Box>
  );
};

export default Chat;





